export default {
  title: {
    index: 'AI Chatbot 配置管理'
  },
  menu: 'AI Chatbot 配置管理',
  btn: {
    uploadAvatar: '上传头像',
    addAction: '添加快捷回复',
    deleteAction: '删除快捷回复'
  },
  label: {
    pageDescription: '配置当前公司的 AI Chatbot 展示信息、提示词和模型参数。',
    basicConfig: '基础配置',
    triggerConfig: '主动触发配置',
    avatar: '机器人头像',
    avatarTip: '请上传一个小于2MB的jpg/jpeg/png/gif文件',
    name: '机器人名称（英文）',
    nameCn: '机器人名称（中文）',
    welcomeMessage: '欢迎语（英文）',
    welcomeMessageCn: '欢迎语（中文）',
    themeColor: '主题色',
    welcomeTrigger: '主动触发 - 首次访问',
    welcomeBackTrigger: '主动触发 - 重复访问相同职位页面',
    stay30sTrigger: '主动触发 - 停留30秒',
    enabled: '启用',
    messageZh: '发送消息（中文）',
    messageEn: '发送消息（英文）',
    actionConfig: '快捷回复配置',
    actionIndex: '快捷回复{index}',
    actionLabelZh: '按钮文案（中文）',
    actionLabelEn: '按钮文案（英文）',
    actionType: '按钮类型',
    actionValue: '按钮值'
  },
  placeholder: {
    themeColor: '请输入十六进制颜色值，例如 #1677FF',
    actionLabelZh: '请输入中文按钮文案',
    actionLabelEn: '请输入英文按钮文案',
    actionType: '请选择按钮类型',
    actionValueInput: '请输入按钮值',
    actionValueSelect: '请选择按钮值',
    messageZh: '请输入中文提示文案',
    messageEn: '请输入英文提示文案'
  },
  option: {
    sendChatbotMessage: '发送消息',
    linkRedirection: '跳转至',
    applyJob: '申请职位'
  },
  message: {
    actionLimit: '你只能添加最多{max}个快捷回复',
    invalidThemeColor: '请输入合法的十六进制颜色值。',
    triggerMessageRequired: '这是个必填字段',
    triggerActionLabelRequired: '这是个必填字段',
    triggerActionValueRequired: '这是个必填字段',
    triggerActionUnsupported: '出现错误，请检查按钮类型或按钮值。'
  }
}
